import React from 'react';

export default class DropDownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    render() {
        let classes = [
                'DropDownMenu', this.props.className
            ],
            menu;

        if (this.state.visible) {
            menu = <ul className="menu">{
                    this
                        .props
                        .options
                        .map((option, i) => <li key={i}>{option}</li>)
                }</ul>;
        }

        return <div onClick={this.handleToggleVisibility.bind(this)} className={classes.join(' ')}>{menu}</div>;
    }
    handleToggleVisibility() {
        this.setState({
            visible: !this.state.visible
        });
    }
}
